export const MONGO_KEYS = {
  OR: 'or',
  AND: 'and',
  GTE: 'gte',
  LTE: 'lte',
  LT: 'lt',
  IN: 'in',
  NIN: 'not-in'
};
